import { render, staticRenderFns } from "./ArticleInfoDecorators.vue?vue&type=template&id=0e422fc5&scoped=true"
import script from "./ArticleInfoDecorators.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoDecorators.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoDecorators.vue?vue&type=style&index=0&id=0e422fc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e422fc5",
  null
  
)

export default component.exports